<app-navbar [PageType]="navType"></app-navbar>
<div class="body-background">
    <div class="container-box">
        <div class="d-flex cursorn" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" [routerLink]="['/home']" [queryParams]="{tag: 'back'}">
            <img src="{{imgSrc}}back-arrow.svg" alt="back-arrow" class="img-fluid">
            <div class="back-to-home">back to home</div>
        </div>

        <div class="step1-box">
            <form [formGroup]="PersonalDetailForm">
                <div class="row">
                    <div class="col-lg-6 col-md-12 col-sm-12">
                        <div class="title-text">Your Title</div>
                        <div class="d-flex">
                            <div *ngFor="let option of options">
                                <button type="button" class="btn" name="Title" [ngClass]="option.isSelect ? 'btn-active' : 'btn-dective'" (click)="ClickTitle(option.id);">{{option.name}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12">
                        <div class="text-01">Your First name</div>
                        <div>
                            <input type="text" id="first-name" class="from-control custom-input" autocomplete="FName-off" formControlName="FName" minlength="2" maxlength="30" (focusout)="keyDownFunction($event)" onkeypress="if(this.value.length==30) return false; return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122  || event.charCode == 32 || event.charCode == 39 || event.charCode == 45"
                                [ngClass]="{ 'is-invalid': f['FName'].touched && f['FName'].errors }" (focus)="FN_ErrorMsg=false; FN_InvalidMsg=false" pattern="^[a-zA-Z](?:[ '.\-a-zA-Z]*[a-zA-Z])?$"/>
                            <div *ngIf="f['FName'].errors" class="invalid-feedback class-margin">
                                <div *ngIf="f['FName'] && f['FName'].errors && f['FName'].errors['required'] || FN_ErrorMsg">
                                    Please enter first name
                                </div>
                                <div *ngIf="f['FName'] && f['FName'].errors && (f['FName'].errors['pattern'] || (f['FName'].errors['minlength'] || FN_InvalidMsg) && !FN_ErrorMsg)">
                                    Please enter a valid first name
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="divider"></div>

                <div class="row">
                    <div class="col-lg-6 col-md-12 col-sm-12">
                        <div class="text-01">Your Surname</div>
                        <div>
                            <input type="text" id="last-name" class="from-control custom-input" autocomplete="LName-off" formControlName="LName" minlength="2" maxlength="30" (focusout)="keyDownFunction($event)" onkeypress="if(this.value.length==30) return false; return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122  || event.charCode == 32 || event.charCode == 39  || event.charCode == 45"
                                [ngClass]="{ 'is-invalid': f['LName'] && f['LName'].touched && f['LName'].errors }" (focus)="LN_ErrorMsg=false; LN_InvalidMsg=false" pattern="^[a-zA-Z](?:[ '.\-a-zA-Z]*[a-zA-Z])?$"/>
                            <div *ngIf="f['LName'] && f['LName'].errors" class="invalid-feedback">
                                <div *ngIf="(f['LName'] && f['LName'].errors && f['LName'].errors['required']) || LN_ErrorMsg">
                                    Please enter last name
                                </div>
                                <div *ngIf="(f['LName'] && f['LName'].errors && (f['LName'].errors['pattern'] || (f['LName'].errors['minlength'] || LN_InvalidMsg) && !LN_ErrorMsg))">
                                    Please enter a valid last name
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12">
                        <div class="text-01">Your Date of Birth</div>
                        <div>
                            <input type="text" class="from-control custom-input" placeholder="DD/MM/YYYY" formControlName="DateOfBirth" autocomplete="off" name="DateOfBirth" minlength="0" maxlength="10" (focus)="focusEvent()" (focusout)="dateofbirth($event)" (keypress)="onlyNumbers($event)"
                                (keyup)="Slash($event)" [ngClass]="{'is-invalid' : RequiredDobMsg || InvalidDate || showDob}" pattern="^\d{2}\/\d{2}\/\d{4}$" />
                            <div class="invalid-feedback">
                                <div *ngIf="RequiredDobMsg">Please enter date of birth</div>
                                <div *ngIf="showDob">{{ageComment}}</div>
                                <div *ngIf="f['DateOfBirth'] && f['DateOfBirth'].errors && (f['DateOfBirth'].errors['pattern'] || f['DateOfBirth'].errors['invalidDate'])">
                                    Please enter a valid date of birth
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="divider"></div>

                <div class="row">

                    <div class="col-lg-6 col-md-12 col-sm-12">
                        <div class="text-01">Your Email Address</div>
                        <div>
                            <input type="email" id="email-box" class="from-control custom-input" formControlName="Email" 
                            autocomplete="off" minlength="2" maxlength="50" (focusout)="onEmailChange($event)" 
                            (focus)="requiredMsg=false; EmailMessage=false;" 
                            [ngClass]="{'is-invalid' : (submitted && f['Email'].errors) || requiredMsg || EmailMessage ||!IsEmailValid}"/>
                            <div class="invalid-feedback class-margin">
                                <div *ngIf="f['Email'] && f['Email'].errors && f['Email'].errors['required'] && requiredMsg">
                                    Email is required
                                </div>
                                <div *ngIf="(EmailMessage && !requiredMsg) ||!IsEmailValid">Please enter a valid email address

                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12">
                        <div class="text-01">Phone Number</div>
                        <div>
                            <input type="text" id="phone" class="from-control custom-input" autocomplete="Number-off" minlength="0" maxlength="11" formControlName="MobileNo" (focusout)="checkMob(f['MobileNo'].value)" onkeypress="if(this.value.length==11) return false;return event.charCode >= 48 && event.charCode <= 57"
                                (keyup)="checkMobileNo(f['MobileNo'].value)" [ngClass]="{'is-invalid' : IsMobileNoRequired || IsMobileNoNotValid ||!IsPhoneValid}" (focus)="IsMobileNoNotValid=false" (focus)="IsMobileNoRequired=false" pattern="^[0][1-9]{1}[0-9]{9}$"/>
                            <div class="invalid-feedback">
                                <div *ngIf="IsMobileNoNotValid || (f['MobileNo'] && f['MobileNo'].errors && f['MobileNo'].errors['pattern'])">
                                    Please enter a valid phone no starting with 07</div>
                                <div *ngIf="IsMobileNoRequired">
                                    Phone number is required</div>
                                <div *ngIf="!IsPhoneValid">
                                    Please enter a valid phone number</div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            <div class="d-flex">
                <button type="submit" class="btn button-step" [disabled]="PersonalDetailForm.invalid || IsMobileNoNotValid || IsMobBtnValid || submitted" (click)="onSubmit();">
                    <div class="container" *ngIf="IsImageLoaded">
                        <div style="margin:1% auto;">
                            <div class="spinner-border custom-spinner-border" role="status"></div>
                        </div>
                    </div>
                    <span *ngIf="!IsImageLoaded">Proceed to Next Step</span>
                </button>
            </div>
        </div>

    </div>
</div>
<app-footer></app-footer>